import { render, staticRenderFns } from "./ModalEnviarManual.vue?vue&type=template&id=0c07946c&scoped=true&"
import script from "./ModalEnviarManual.vue?vue&type=script&lang=js&"
export * from "./ModalEnviarManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07946c",
  null
  
)

export default component.exports